import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const SidebarMenu = () => {
    const navLinkClass = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

    return (
        <aside className="app-sidebar bg-body-secondary shadow" data-bs-theme="dark">

            <div className="sidebar-brand">

                <Link to="/backoffice" className="brand-link">

                    <img src={require('../assets/images/logo-new.png')} alt="KAV2GO"
                         className="brand-image"/>

                </Link>

            </div>

            <div className="sidebar-wrapper" data-overlayscrollbars="host">
                <div className="os-size-observer">
                    <div className="os-size-observer-listener"></div>
                </div>
                <div className="" data-overlayscrollbars-viewport="scrollbarHidden overflowXHidden overflowYScroll"
                     tabIndex={-1}
                     style={{
                         marginRight: "-16px",
                         marginBottom: "-16px",
                         marginLeft: "0px",
                         top: "-8px",
                         right: "auto",
                         left: "-8px",
                         width: "calc(95% + 16px)",
                         padding: "8px",
                     }}
                >
                    <nav className="mt-2">

                        <ul className="nav sidebar-menu flex-column" data-lte-toggle="treeview" role="navigation"
                            aria-label="Main navigation" data-accordion="false" id="navigation">
                            <li className="nav-item">
                                <NavLink to="/backoffice" className={navLinkClass} end>
                                    <i className="nav-icon bi bi-speedometer"></i>
                                    <p>
                                        Dashboard
                                    </p>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/backoffice/locations" className={navLinkClass}>
                                    <i className="nav-icon bi bi-geo-alt"></i>
                                    <p>Locations</p>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/backoffice/vehicles" className={navLinkClass}>
                                    <i className="nav-icon bi bi-truck"></i>
                                    <p>Vehicles</p>
                                </NavLink>
                            </li>


                        </ul>

                    </nav>
                </div>

            </div>

        </aside>
    )
}

export default SidebarMenu
